<p-toast [baseZIndex]="100"></p-toast>
<app-spinner></app-spinner>
@if ((configLoaded || (configLoaded && publicRoute)) && mountRouter) {
  <div class="container">
    <app-header></app-header>
    @if (((checkedLogin && userLoaded) || publicRoute) && mountRouter) {
      <router-outlet></router-outlet>
    }
  </div>
}
<app-footer></app-footer>
